module.exports = __webpack_public_path__ + "img/32-ABITO-RODA-U-COLORI-GARZA9.ad9b19da.jpg";